import { createContext, useState, useContext } from "react";
import Const from "./constant";

const StoreContext = createContext({});

export const ContextProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem(Const.STORAGE_KEYS.USER));
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem(Const.STORAGE_KEYS.USER);
    return storedUser ? JSON.parse(storedUser) : {};
  });

  const handleLogin = (user) => {
    setIsAuthenticated(true);
    setUser(user);
    localStorage.setItem(Const.STORAGE_KEYS.USER, JSON.stringify(user));
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser({});
    localStorage.removeItem(Const.STORAGE_KEYS.USER);
  };

  return (
    <StoreContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        handleLogin,
        handleLogout,
        user,
        setUser,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  return useContext(StoreContext);
};
